import config from "../../../Libs/config";
import { API } from "aws-amplify";

type SubmitResponseParams = {
	response: {
		name: string;
		question: string;
		value: string;
	}[];
	formId: string;
};

type GetQuestionParams = {
	formId: string;
};

export const webFormSubmitResponse = async (params: SubmitResponseParams) => {
	const apiName = config.apiGateway.WebForm.NAME;
	const path = "/webForm/response";
	return API.post(apiName, path, {
		body: params,
	});
};

export const getQuestions = async (params: GetQuestionParams) => {
	const apiName = config.apiGateway.WebForm.NAME;
	const path = "/webForm/questions";
	return API.get(apiName, path, {
		queryStringParameters: {
			formId: params.formId,
		},
	});
};
